import script from "./Burger.vue?vue&type=script&setup=true&lang=js"
export * from "./Burger.vue?vue&type=script&setup=true&lang=js"

import "./Burger.vue?vue&type=style&index=0&id=cdc02972&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdc02972"]])

export default __exports__